
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconCardinalSouth as ObiSimplifiedBeaconCardinalSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-cardinal-south.js';
 
 
 

 
 export const ObiSimplifiedBeaconCardinalSouth = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-cardinal-south',
   elementClass: ObiSimplifiedBeaconCardinalSouthElement,
   events: {
     
   }
  });
 
 